import { render } from "./PieCharts.vue?vue&type=template&id=d09f347c&lang=pug"
import script from "./PieCharts.vue?vue&type=script&setup=true&lang=js"
export * from "./PieCharts.vue?vue&type=script&setup=true&lang=js"

import "./PieCharts.vue?vue&type=style&index=0&id=d09f347c&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__